import React from 'react'

import FormManager from '../../../gd-form/common/form-manager'
import FormError from "../../../gd-form/common/form-error/form-error"
import Form from '../../../gd-form/form/form-add/form-add'
import Input from '../../../gd-form/form-element/input/input'
import Document from "../../../model2/doc/document"
import ApiDocument from "../../../gd/api/document"
import {EntityType} from "../../../gd/const/item"
import {SelectParent_RenderType} from "../../../gd-ui/select-parent-new/@const"
import SelectParentNew from "../../../gd-ui/select-parent-new/select-parent-new"


type Props = {
    document         : Document
    callback?        : callback
}

// const debug = "ModalDocument_Duplicate"
const debug = false

export default class ModalDocument_Duplicate extends React.Component<Props> {


    private copyOptions: any[] = [] // we dont use it at the moment
    private form: FormManager

    constructor(props: Props) {
        super(props);

        debug && console.log(debug, "constructor() props=", this.props)


        const initFormData = {
            name            : this.props.document.name + " - copy",
            parentProject   : this.props.document.projectId
        };

        const formStructure = {
            isFormChanged: true,
            fields: {
                name: {
                    type: 'select',
                    isRequired: true,
                },
                parentProject: {
                    type: 'select',
                    isRequired: false,
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = async (result: any) => {
        debug && console.log(debug,"onSubmit() result=", result)

        // await apiCall
        const response:any = await ApiDocument.duplicate(
            this.props.document.id,
            result.parentProject,
            result.name
        ).promise()

        gd.modal.hide()

        this.props.callback && this.props.callback()

    }

    onParentSelected = (projectId: ID) => {
        this.form.setFieldValue("parentProject", projectId)
    }

    render() {
        const projectId = this.props.document.projectId

        // const submitLabel       = this.props.copyAsTemplate ? "Save as template" : "Copy";
        const submitLabel       = "Duplicate"


        // const showCopyOptions   = !this.props.project.isPage && !this.props.project.isLink && !this.props.project.isEmbed

        return (
            <Form form={this.form} submitLabel={submitLabel} className="project-copy">
                <div className="tbl">

                    <div className="row">
                        <div className="label">Name</div>
                        <div className="element">
                            <Input size="big" form={this.form} name="name"/>
                            <FormError form={this.form} name="name" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="label">New location</div>
                        <div className="element">

                            <SelectParentNew projectId      = {projectId}
                                             parentsFor     = {EntityType.DOCUMENT}
                                             placeholder    = "Select project"
                                             renderType     = {SelectParent_RenderType.FORM}
                                             onChange       = {this.onParentSelected}/>

                            {/*<SelectParent onChange                  = {this.onParentSelected}
                                          companies                 = {[gd.companyId]}
                                          parentsFor                = "document"
                                          value                     = {parentValue}
                                          showOnlyFilterProjects    = {true}
                                          singleCompanyVisible      = {true}
                                          scrollContentStyle        = {{height: 300}}/>*/}

                            <FormError form={this.form} name="parentProject" />
                        </div>
                    </div>

                </div>
            </Form>
        )
    }
}